import { getData, getScanDate } from '@/components/report/service';
import ActualDetail from '@/Entity/ActualDetail';
import { SuperiorityProduct } from '@/Entity/PublicEntity';
import RouteEntity from '@/Entity/RouteEntity';
import GenerateCondit, { Bound } from '@/models/GenerateCondit';
import { CALCWEIGHT, getToDay } from '@/models/GenerateCondit/Interrelated';
import { crudRequest } from '@/services/api';
import { signOfflineBatch, selectPageList, exportDataNew } from '@/services/waybillCashRateNew';
import moment, { utc } from 'moment';
import { message } from 'antd';

const today = new Date();

const params = {
  waybillNo: '',
  originProvince: '',
  countyAgingOriginCenter: '',
  isProduct: undefined, //[SuperiorityProduct.YES, SuperiorityProduct.NO],
  startDate: moment(today).add(-1, 'days').format('YYYY-MM-DD 00:00:00'),
  destinationProvinceArea: '',
  countyAgingDestinationCenter: '',
  productType: [],
};

const actualTable = 'static_actual_time_consume_result'; // 实际表
const preTable = 'static_actual_time_consume_result_sat';

export default {
  namespace: 'waybillcashratenew',
  state: {
    searchParams: { ...params },
    dataList: [],
    dataSql: '',
    page: 1,
    pageSize: 20,
    scheduleImportVo: [],
    messageInfo: '',
    // importLoding: false,
  },

  effects: {
    *getData({ payload }, { put, call, select }) {
      const waybillcashratenew = yield select(({ waybillcashratenew }) => waybillcashratenew);
      const { searchParams, page, pageSize } = waybillcashratenew;
      let { dataList } = waybillcashratenew;
      const {
        startDate,
        waybillNo,
        originProvince,
        countyAgingOriginCenter,
        isProduct,
        destinationProvinceArea,
        countyAgingDestinationCenter,
        productType,
      } = searchParams;
      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      const pages = payload?.page ?? page;

      let result = yield call(selectPageList, {
        waybillNo,
        originArea: originProvince?.code,
        originCenterCode: countyAgingOriginCenter?.code,
        isSuperiorityProduct: isProduct,
        destinationArea: destinationProvinceArea?.code,
        destinationCenterCode: countyAgingDestinationCenter?.code,
        productType: productType,
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(startDate).format('YYYY-MM-DD 23:59:59'),
        queryType: 'scan',
        page: pages,
        pageSize,
      });

      yield put({
        type: 'updateState',
        payload: {
          dataList: result?.data?.rows || [],
          total: result?.data?.total || 0,
          page: pages,
        },
      });
    },

    *dataExport({ payload }, { call, put, select }) {
      const waybillcashratenew = yield select(({ waybillcashratenew }) => waybillcashratenew);
      const { searchParams, page, pageSize } = waybillcashratenew;

      const {
        startDate,
        waybillNo,
        originProvince,
        countyAgingOriginCenter,
        isProduct,
        destinationProvinceArea,
        countyAgingDestinationCenter,
        productType,
      } = searchParams;

      const pages = payload?.page ?? page;

      let result = yield call(exportDataNew, {
        waybillNo,
        originArea: originProvince?.code,
        originCenterCode: countyAgingOriginCenter?.code,
        isSuperiorityProduct: isProduct,
        destinationArea: destinationProvinceArea?.code,
        destinationCenterCode: countyAgingDestinationCenter?.code,
        productType: productType,
        startDate: moment(startDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(startDate).format('YYYY-MM-DD 23:59:59'),
        queryType: 'scan',
        page: pages,
        pageSize,
        ...payload,
      });
      try {
        if (result?.code === 1) {
          message.success('导出成功');
          yield put({
            type: 'updateState',
            payload: {
              exportVisible: false,
            },
          });
          // yield put({
          //   type: 'filedownload/deliveryDisAccordExport',
          //   payload: {
          //     ...searchParams,
          //     endDate: moment(searchParams.startDate).format('YYYY-MM-DD HH:mm:ss'),
          //     startDate: moment(searchParams.endDate).format('YYYY-MM-DD HH:mm:ss'),
          //   }
          // });
        }
      } catch (err) {
        message.warn(err.message);
      }
    },

    // 导入
    *signOfflineBatch({ callBack }, { select, call }) {
      const { scheduleImportVo } = yield select(({ waybillcashratenew }) => waybillcashratenew);
      if (!scheduleImportVo?.length) return message.error('导入文件数据为空');
      const result = yield call(signOfflineBatch, { staticSignOfflineImportVos: scheduleImportVo });
      // console.log(result)
      if (result?.code === 1) {
        // message.success( result.message || '导入成功！')
        callBack && callBack(result);
      } else {
        message.error('导入文件出现异常,服务端没有响应!');
      }
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },
  },
};
